import React from 'react';
import { useTranslation } from 'react-i18next';

interface Benefit {
  text: string;
  highlight?: boolean;
}

export interface MemberLevelCardData {
  tag: string;
  tagColor: string;
  tagBg: string;
  points: string;
  icon: React.ReactNode;
  benefits: Benefit[];
  detailsLink?: string;
}

interface MemberLevelCardsProps {
  data: MemberLevelCardData[];
  className?: string;
}

const MemberLevelCards: React.FC<MemberLevelCardsProps> = ({ data, className = '' }) => {
  const { t } = useTranslation('soul');
  
  return (
  <div className={`grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:px-0 ${className}`}>
    {data.map((item, idx) => (
      <div
        key={idx}
        className="w-full rounded-xl border border-[#44403C] px-[20px] py-[24px] sm:p-[28px]"
      >
        {/* Tag */}
        <div
          className="w-auto block p-[8px] font-bold text-[20px] sm:text-[24px] mb-6 leading-none w-fit"
          style={{ background: item.tagBg, color: item.tagColor }}
        >
          {item.tag}
        </div>
        <div className="flex items-center justify-between">
          {/* Points */}
          <div className="flex flex-col items-start">
            <div className={`${item.points.length > 5 ? 'text-24 sm:text-32' : 'text-32 sm:text-48'} font-extrabold text-white mb-1`}>{item.points}</div>
            <div className="text-sm text-[#b0b0b0] mb-6">{t('soul_48_soul_points')}</div>
          </div>
          
          {/* Icon */}
          <div className="mb-4 flex justify-end">
            {item.icon}
          </div>
        </div>
        
        {item.benefits.length > 0 && (
          <>
            <div className="text-xs text-[#b0b0b0] mb-[8px]">{t('soul_benefits')}</div>
            <ul className="">
              {item.benefits.map((b, i) => (
                <li key={i} className="flex items-center justify-between text-gray-200 text-14 sm:text-16 mb-[8px]">
                  <span className={b.highlight ? 'text-[#FFD166]' : ''}>{b.text}</span>
                  <img src="/check-verified.svg" alt="check" className="w-[20px] h-[20px]" />
                </li>
              ))}
            </ul>
          </>
        )}
        {/* Details Link */}
        {item.detailsLink && (
          <a
            href={item.detailsLink}
            className="text-[#FFD166] text-xs font-medium mt-2 inline-block"
          >
{t('soul_view_details')}
          </a>
        )}
      </div>
    ))}
  </div>
  );
};

export default MemberLevelCards;